import * as $http from 'axios';

export default {
  list: (params) => $http.get(`/appointments/holidays`, { params }), // 공휴일 리스트-query example:locdateEndAt=2020-12-31&locdateStartAt=2020-01-01&orderBy=locdate asc
};
